import { useAuth } from "@/lib/hooks/useAuth";
import { AdminRecordingsTab } from "./AdminRecordingsTab";

// Department-scoped recordings view. Reuses AdminRecordingsTab; the backend
// scopes the data by the caller's role (superuser = all, dept_admin/secretary
// = own department). Superusers get a hospital -> department picker to inspect
// any afdeling. No delete on this tab.
export function AdminDeptRecordingsTab() {
  const { accessRole } = useAuth();
  const isSuperuser = accessRole === "superuser";
  return <AdminRecordingsTab mode="department" canDelete={false} showDeptPicker={isSuperuser} />;
}
